import React from 'react';
import Container from '../container';
import LazyImage from '../lazy-image';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import RichtextParser from '../../utils/richtext-parser';
import styled, { css } from 'styled-components';
import mq from '../../utils/mq';

const CaseStudyTestimonialContainerOuter = styled.div`
  background: #161616;
  padding: 100px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mq.mobile(css`
    padding: 32px 0;
  `)};
`;

const CaseStudyTestimonialContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  align-items: flex-start;
  ${mq.mobile(css`
    flex-direction: column;
  `)};
`;

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  max-width: 276px;
  width: 100%;
  flex-shrink: 0;
  ${mq.mobile(css`
    max-width: unset;
  `)};
`;

const AssociatedCompanyLogo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  position: relative;
  max-width: 176px;
`;

const AssociatedCompanyDescription = styled.div`
  color: #c4c4c4;
  text-wrap: balance;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.15px;
`;

const RightContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 636px;
  ${mq.mobile(css`
    max-width: unset;
  `)};
`;

const QuoteContent = styled.div`
  width: 100%;
  padding-bottom: 40px;
`;

const Quote = styled.div`
  color: #fff;
  font-size: 27px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.54px;
  ${mq.mobile(css`
    font-size: 22px;
  `)};
  p {
    position: relative;
    &:first-child {
      position: relative;
      ${mq.mobile(css`
        margin-top: 20px;
      `)};
      &::before {
        content: '“';
        position: absolute;
        color: #8a55fb;
        font-size: 42px;
        font-style: normal;
        font-weight: 700;
        line-height: 0;
        letter-spacing: -0.84px;
        top: 14px;
        left: -22px;
        ${mq.mobile(css`
          top: 0;
          left: 0;
          font-size: 60px;
        `)};
      }
    }
    &:last-child {
      display: inline-block;
      position: relative;

      &::after {
        content: '”';
        color: #8a55fb;
        font-size: 42px;
        font-style: normal;
        font-weight: 700;
        line-height: 0;
        letter-spacing: -0.84px;
        margin-left: 2px;
        vertical-align: baseline;
        position: relative;
        top: 6px;
        ${mq.mobile(css`
          top: 10px;
        `)};
      }
    }
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;

const QuoteeInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 3px;
  flex-direction: column;
`;

const QuoteeName = styled.div`
  color: #fff;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 125%;
  letter-spacing: -0.48px;
`;

const QuoteeRole = styled.div`
  color: #c4c4c4;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.15px;
`;

export default function CaseStudyTestimonial({
  quote,
  quoteeName,
  quoteeRole,
  associatedCompanyLogo,
  associatedCompanyDescription
}: {
  quote: any;
  quoteeName: string;
  quoteeRole: string;
  associatedCompanyLogo: any;
  associatedCompanyDescription: any;
}) {
  return (
    <CaseStudyTestimonialContainerOuter>
      <Container>
        <CaseStudyTestimonialContainer>
          <LeftContent>
            <AssociatedCompanyLogo>
              <LazyImage
                fluid={getFluidGatsbyImage(associatedCompanyLogo)}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                width={'100%'}
                height={'100%'}
              />
            </AssociatedCompanyLogo>
            <AssociatedCompanyDescription>
              {associatedCompanyDescription}
            </AssociatedCompanyDescription>
          </LeftContent>
          <RightContent>
            <QuoteContent>
              <Quote
                dangerouslySetInnerHTML={{ __html: RichtextParser(quote) }}
              />
            </QuoteContent>
            <QuoteeInfo>
              <QuoteeName>{quoteeName}</QuoteeName>
              <QuoteeRole>{quoteeRole}</QuoteeRole>
            </QuoteeInfo>
          </RightContent>
        </CaseStudyTestimonialContainer>
      </Container>
    </CaseStudyTestimonialContainerOuter>
  );
}
